export const getColumns = () => [
    {
        title: 'Текст поста',
        dataIndex: 'text',
    },
    {
        title: 'Просмотры',
        dataIndex: 'views_count',
    },
    {
        title: 'Реакции',
        dataIndex: 'reactions_count',
    },
    {
        title: 'Дата создания',
        dataIndex: 'created_at',
    },
];
